import { type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { LanguageSelector } from '@/components/LanguageSelector'

/**
 * Shared chrome for the unauthenticated pages (login, register, password reset,
 * invite acceptance): centered card area, the brand header, and the language
 * selector. Pages render only their <Card>. Pass `tagline` to override the
 * default app tagline under the brand name.
 */
export function AuthLayout({ children, tagline }: { children: ReactNode; tagline?: string }) {
  const { t } = useTranslation(['auth', 'common'])
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="absolute right-4 top-4">
        <LanguageSelector compact />
      </div>
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <h1 className="text-2xl font-bold text-gray-900">{t('common:appName')}</h1>
          <p className="mt-1 text-sm text-muted-foreground">{tagline ?? t('tagline')}</p>
        </div>
        {children}
      </div>
    </div>
  )
}
